import type { TdhApi } from '@ipen-portal/backstage-plugin-tdh-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const tdhApiRef = createApiRef<TRPCOptionsProxy<TdhApi>>().with({
  id: 'plugin.ipen.tdh.api',
});
